/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaFinding from './AqaFinding';

/**
 * The AqaVector model module.
 * @module model/AqaVector
 * @version v0
 */
export default class AqaVector {
  /**
   * Constructs a new <code>AqaVector</code>.
   * @alias module:model/AqaVector
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaVector</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaVector} obj Optional instance to populate.
   * @return {module:model/AqaVector} The populated <code>AqaVector</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaVector();
      if (data.hasOwnProperty('findings'))
        obj.findings = ApiClient.convertToType(data['findings'], {'String': [AqaFinding]});
      if (data.hasOwnProperty('snapshotId'))
        obj.snapshotId = ApiClient.convertToType(data['snapshotId'], 'String');
      if (data.hasOwnProperty('orientation'))
        obj.orientation = ApiClient.convertToType(data['orientation'], 'String');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('originalPosition'))
        obj.originalPosition = ApiClient.convertToType(data['originalPosition'], 'Number');
      if (data.hasOwnProperty('numberOfDifferentTypes'))
        obj.numberOfDifferentTypes = ApiClient.convertToType(data['numberOfDifferentTypes'], 'Number');
      if (data.hasOwnProperty('numberOfMissings'))
        obj.numberOfMissings = ApiClient.convertToType(data['numberOfMissings'], 'Number');
      if (data.hasOwnProperty('numberOfEmpties'))
        obj.numberOfEmpties = ApiClient.convertToType(data['numberOfEmpties'], 'Number');
      if (data.hasOwnProperty('numberOfMissingsOrEmpties'))
        obj.numberOfMissingsOrEmpties = ApiClient.convertToType(data['numberOfMissingsOrEmpties'], 'Number');
      if (data.hasOwnProperty('specialUniform'))
        obj.specialUniform = ApiClient.convertToType(data['specialUniform'], 'Boolean');
      if (data.hasOwnProperty('uniformityType'))
        obj.uniformityType = ApiClient.convertToType(data['uniformityType'], 'Number');
      if (data.hasOwnProperty('uniformType'))
        obj.uniformType = ApiClient.convertToType(data['uniformType'], 'String');
      if (data.hasOwnProperty('typeCounts'))
        obj.typeCounts = ApiClient.convertToType(data['typeCounts'], ['Number']);
      if (data.hasOwnProperty('numberOfUniques'))
        obj.numberOfUniques = ApiClient.convertToType(data['numberOfUniques'], 'Number');
      if (data.hasOwnProperty('highestNumberOfRepeats'))
        obj.highestNumberOfRepeats = ApiClient.convertToType(data['highestNumberOfRepeats'], 'Number');
      if (data.hasOwnProperty('dateFormat'))
        obj.dateFormat = ApiClient.convertToType(data['dateFormat'], 'String');
      if (data.hasOwnProperty('distributions'))
        obj.distributions = ApiClient.convertToType(data['distributions'], {'String': {'String': 'Number'}});
      if (data.hasOwnProperty('matrix'))
        obj.matrix = ApiClient.convertToType(data['matrix'], [['Boolean']]);
      if (data.hasOwnProperty('header'))
        obj.header = ApiClient.convertToType(data['header'], 'String');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('uniformFlag'))
        obj.uniformFlag = ApiClient.convertToType(data['uniformFlag'], 'Boolean');
      if (data.hasOwnProperty('numberOfDuplicates'))
        obj.numberOfDuplicates = ApiClient.convertToType(data['numberOfDuplicates'], 'Number');
      if (data.hasOwnProperty('firstCellStringFlag'))
        obj.firstCellStringFlag = ApiClient.convertToType(data['firstCellStringFlag'], 'Boolean');
      if (data.hasOwnProperty('specialUniformFlag'))
        obj.specialUniformFlag = ApiClient.convertToType(data['specialUniformFlag'], 'Boolean');
      if (data.hasOwnProperty('allDictionaryWordsFlag'))
        obj.allDictionaryWordsFlag = ApiClient.convertToType(data['allDictionaryWordsFlag'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Object.<String, Array.<module:model/AqaFinding>>} findings
 */
AqaVector.prototype.findings = undefined;

/**
 * @member {String} snapshotId
 */
AqaVector.prototype.snapshotId = undefined;

/**
 * Allowed values for the <code>orientation</code> property.
 * @enum {String}
 * @readonly
 */
AqaVector.OrientationEnum = {
  /**
   * value: "column"
   * @const
   */
  column: "column",

  /**
   * value: "row"
   * @const
   */
  row: "row"
};
/**
 * @member {module:model/AqaVector.OrientationEnum} orientation
 */
AqaVector.prototype.orientation = undefined;

/**
 * @member {Number} position
 */
AqaVector.prototype.position = undefined;

/**
 * @member {Number} originalPosition
 */
AqaVector.prototype.originalPosition = undefined;

/**
 * @member {Number} numberOfDifferentTypes
 */
AqaVector.prototype.numberOfDifferentTypes = undefined;

/**
 * @member {Number} numberOfMissings
 */
AqaVector.prototype.numberOfMissings = undefined;

/**
 * @member {Number} numberOfEmpties
 */
AqaVector.prototype.numberOfEmpties = undefined;

/**
 * @member {Number} numberOfMissingsOrEmpties
 */
AqaVector.prototype.numberOfMissingsOrEmpties = undefined;

/**
 * @member {Boolean} specialUniform
 */
AqaVector.prototype.specialUniform = undefined;

/**
 * @member {Number} uniformityType
 */
AqaVector.prototype.uniformityType = undefined;

/**
 * Allowed values for the <code>uniformType</code> property.
 * @enum {String}
 * @readonly
 */
AqaVector.UniformTypeEnum = {
  /**
   * value: "unknown"
   * @const
   */
  unknown: "unknown",

  /**
   * value: "string"
   * @const
   */
  _string: "string",

  /**
   * value: "number"
   * @const
   */
  _number: "number",

  /**
   * value: "date"
   * @const
   */
  _date: "date",

  /**
   * value: "nativeError"
   * @const
   */
  nativeError: "nativeError"
};
/**
 * @member {module:model/AqaVector.UniformTypeEnum} uniformType
 */
AqaVector.prototype.uniformType = undefined;

/**
 * @member {Array.<Number>} typeCounts
 */
AqaVector.prototype.typeCounts = undefined;

/**
 * @member {Number} numberOfUniques
 */
AqaVector.prototype.numberOfUniques = undefined;

/**
 * @member {Number} highestNumberOfRepeats
 */
AqaVector.prototype.highestNumberOfRepeats = undefined;

/**
 * @member {String} dateFormat
 */
AqaVector.prototype.dateFormat = undefined;

/**
 * @member {Object.<String, Object.<String, Number>>} distributions
 */
AqaVector.prototype.distributions = undefined;

/**
 * @member {Array.<Array.<Boolean>>} matrix
 */
AqaVector.prototype.matrix = undefined;

/**
 * @member {String} header
 */
AqaVector.prototype.header = undefined;

/**
 * @member {String} id
 */
AqaVector.prototype.id = undefined;

/**
 * @member {Boolean} uniformFlag
 */
AqaVector.prototype.uniformFlag = undefined;

/**
 * @member {Number} numberOfDuplicates
 */
AqaVector.prototype.numberOfDuplicates = undefined;

/**
 * @member {Boolean} firstCellStringFlag
 */
AqaVector.prototype.firstCellStringFlag = undefined;

/**
 * @member {Boolean} specialUniformFlag
 */
AqaVector.prototype.specialUniformFlag = undefined;

/**
 * @member {Boolean} allDictionaryWordsFlag
 */
AqaVector.prototype.allDictionaryWordsFlag = undefined;

